import React from 'react'
import { Link, Imgix } from '@elements'
import { lowercaseNoSpaces } from '@utils'

export const MediaKit = ({ mediaKit, categoryTitle }) => {
  const sectionId = lowercaseNoSpaces(categoryTitle)
  return (
    <section className="py-20" id={sectionId}>
      <div className="container">
        <h2 className="font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
          {categoryTitle}
        </h2>
        <div className="grid gap-16 pt-10 mt-6 border-t-2 border-gray-400 lg:grid-cols-3 lg:col-gap-5 lg:row-gap-12">
          {mediaKit &&
            mediaKit.map((download, idx) => {
              return (
                <div key={idx} className="w-full max-w-md mx-auto">
                  <Link
                    to={
                      download.mediaKitDownload &&
                      download.mediaKitDownload.mediaItemUrl
                    }
                    download
                    className="block"
                  >
                    {download.thumbnailImage && (
                      <div className="relative w-full">
                        <Imgix
                          src={download.thumbnailImage.mediaItemUrl}
                          alt={download.thumbnailImage.altText}
                          className="w-full h-auto"
                        />
                      </div>
                    )}
                    <h3 className="mt-4 font-sans text-2xl font-bold leading-7 text-gray-400 uppercase">
                      {download.mediaKitTitle}
                    </h3>
                    <p className="mt-3 text-base leading-6 text-gray-500">
                      {download.mediaKitDescription}
                    </p>
                  </Link>
                  {download.mediaKitDownload && (
                    <div className="mt-3">
                      <Link
                        to={download.mediaKitDownload.mediaItemUrl}
                        download
                        className="font-sans text-base font-bold leading-6 text-gray-400 no-underline uppercase transition duration-150 ease-in-out border-b-4 hover:border-brand-yellow"
                      >
                        Download
                      </Link>
                    </div>
                  )}
                </div>
              )
            })}
        </div>
      </div>
    </section>
  )
}
